import { EventMeta } from '../../../interfaces/meta.interface';

const send: EventMeta = {
    title: 'Message Sent',
    default: {
        description: 'Message Sent',
        longDescription: 'A message was sent.',
        severity: 'info',
    },
};

export default send;
